/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_NOTIFICATIONS_HELP = {
  screenId: 'settings-notifications',
  label: 'Notificaciones',
  navPath: 'Configuración → Notificaciones',
  keywords: ['push', 'alertas', 'aviso', 'stock mínimo', 'preferencias'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Elegí qué avisos del sistema querés recibir en tu usuario.',
  sidebarItems: [{
    id: 'notifications',
    screenId: 'settings-notifications',
    label: 'Preferencias de notificaciones',
    description: 'Activar o desactivar tipos de aviso.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Configurás qué notificaciones recibís en el sistema. Solo aparecen avisos de áreas a las que tenés acceso.',
        },
        {
          title: 'Paso 1 — Abrir la ventana',
          steps: [
            'Entrá a Configuración → Notificaciones.',
            'Se listan los tipos de aviso disponibles con un interruptor cada uno.',
          ],
        },
        {
          title: 'Paso 2 — Activar o desactivar',
          bullets: [
            'Cada fila muestra el nombre del aviso y, si aplica, una breve descripción.',
            'Marcá o desmarcá el interruptor según te interese recibir ese tipo de notificación.',
            'Algunos avisos pueden estar bloqueados (interruptor deshabilitado) si el sistema los considera obligatorios.',
          ],
          paragraphs: [
            'Ejemplo: «Stock bajo mínimo» avisa cuando un artículo queda por debajo del mínimo en un depósito al que tenés acceso.',
          ],
        },
        {
          title: 'Paso 3 — Guardar',
          paragraphs: ['Tocá «Guardar» para aplicar los cambios a tu usuario.'],
        },
      ],
    },
  }],
}
